export default function AboutHero() {
  return (
    <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/0d1a9799d533276a14df8166f3f52c4d.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-black/60"></div>
      
      <div className="relative z-10 text-center px-4">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
          About KaliKare
        </h1>
        <p className="text-lg sm:text-xl text-white/90 max-w-2xl mx-auto">
          Dedicated to providing exceptional homecare with compassion and professionalism
        </p>
      </div>
    </section>
  );
}
